<template>
  <div class="my-4 ml-4">
    <button
      type="button"
      @click="requestXlsxExport"
      :disabled="isGeneratingXlsx"
      class="btn-brand-light inline-flex items-center gap-2"
    >
      <DownloadIcon />
      <span>
        <Translation
          v-if="isGeneratingXlsx"
          name="report.generating_xlsx"
          default="Generating XLSX..."
        />
        <Translation
          v-else
          name="report.export_to_excel"
          default="Export to Excel"
        />
      </span>
    </button>

    <p
      v-if="xlsxErrorMessage"
      class="mt-2 text-xs font-semibold text-red-600"
    >
      {{ xlsxErrorMessage }}
    </p>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from "vue";
import { useExportPoller } from "../utils/useExportPoller";
import Translation from "./aft/Translation.vue";
import DownloadIcon from "./icons/DownloadIcon.vue";

export default {
  name: "ReportGenderDisparityXlsxButton",
  components: { Translation, DownloadIcon },
  props: {
    generateUrl: { type: String, required: true },
    statusUrl: { type: String, required: true },
  },
  setup(props) {
    const noop = () => {};

    const poller = useExportPoller({
      getUrls: () => ({
        url: props.generateUrl,
        status_url: props.statusUrl,
      }),
      errorLabel: "XLSX generation failed. Please try again.",
      closeDropdown: noop,
    });

    onMounted(() => poller.checkStatusOnLoad());
    onUnmounted(() => poller.stopPolling());

    return {
      isGeneratingXlsx: poller.isGenerating,
      xlsxErrorMessage: poller.errorMessage,
      requestXlsxExport: poller.requestExport,
    };
  },
};
</script>
